/* eslint-disable */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClinicGroupLinkRequestRespondModel } from '../../models/clinic-group-link-request-respond-model';
import { ClinicGroupLinkRequestRespondResultModel } from '../../models/clinic-group-link-request-respond-result-model';

export interface ClinicGroupLinkRequestRespondPost$Params {
  body?: ClinicGroupLinkRequestRespondModel
}

export function clinicGroupLinkRequestRespondPost(
  http: HttpClient,
  rootUrl: string,
  params?: ClinicGroupLinkRequestRespondPost$Params,
  context?: HttpContext
): Observable<PracticeStrictHttpResponse<ClinicGroupLinkRequestRespondResultModel>> {
  const rb = new RequestBuilder(rootUrl, clinicGroupLinkRequestRespondPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<ClinicGroupLinkRequestRespondResultModel>;
    })
  );
}

clinicGroupLinkRequestRespondPost.PATH = '/ClinicGroup/LinkRequest/Respond';
